// extracted by mini-css-extract-plugin
export default {"navbar":"Navbar_navbar__KyRFQ","nav-container":"Navbar_nav-container__QzATz","dash-title":"Navbar_dash-title__ZTemW","infoIcon":"Navbar_infoIcon__23JcR"};